import { render } from "./EditCollections.vue?vue&type=template&id=1d85e0c0&scoped=true"
import script from "./EditCollections.vue?vue&type=script&lang=js"
export * from "./EditCollections.vue?vue&type=script&lang=js"

import "./EditCollections.vue?vue&type=style&index=0&id=1d85e0c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d85e0c0"]])

export default __exports__